import React, { useEffect, useState } from 'react';
import Navigation from './Navigation';
import { navigationItems } from '../../config/navigationConfig';
import { fetchOrganizationMenu } from '../../services/Http/Api';

// Retailer navigation: render only the menu items an admin has enabled for this
// organisation (GET /organizations/menu). Falls back to the full default set on
// error or empty response so the sidebar is never blank.
const RetailerNavigation = (props) => {
    const [items, setItems] = useState(navigationItems);

    useEffect(() => {
        let active = true;
        fetchOrganizationMenu()
            .then((menu) => {
                if (!active || !Array.isArray(menu)) return;
                const enabledPaths = new Set(
                    menu.filter((m) => m && m.is_enabled).map((m) => m.path)
                );
                const filtered = navigationItems.filter((item) => enabledPaths.has(item.path));
                setItems(menu.length > 0 ? filtered : navigationItems);
            })
            .catch(() => {
                /* keep default items on failure */
            });
        return () => {
            active = false;
        };
    }, []);

    return <Navigation {...props} items={items} />;
};

export default RetailerNavigation;
